const STANDARD_RESOLUTIONS = {
  '720p': { width: 1280, height: 720 },
  '1080p': { width: 1920, height: 1080 },
  '2K': { width: 2048, height: 1080 },
  '1440p': { width: 2560, height: 1440 },
  '4K': { width: 3840, height: 2160 },
  '8K': { width: 7680, height: 4320 },
} as const;

export const __BASE_SIZE = STANDARD_RESOLUTIONS['720p'];

export const __BORDER_WIDTH = {
  min: 0,
  max: 10,
  step: 0.01,
};

export const __FONT_SIZE = {
  min: 22,
  max: 199,
  step: 0.5,
};

export const __POSITION = {
  min: 0,
  max: 1,
  step: 0.01,
};
